module.exports = __webpack_public_path__ + "static/media/03_05_01.29263366.png";